import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import SocialMedia from "../../components/commonSection/social-media/SocialMedia";
import { fetchTextInfo } from "../../store/actions";
import Popup from "../../components/popup/Popup";
import FooterApk from "../footer/FooterApk";
import MenuHelper from "../../helpers/MenuHelper";
import { ChatConfig } from "../../pages/utility/ChatConfig";
import LiveChat from "../../components/livechat/LiveChat";

const FooterMobile = (props) => {
  useEffect(() => {
    // alert('footer-mobile');
  }, []);
  const loggedIn = window.localStorage.getItem("user_token");
  const location = useLocation();
  const dispatch = useDispatch();
  const isDepositActive = location.pathname === "/validation";

  const { componentSetting, copyrightInformation, playerMenu, userProfile } = useSelector((state) => ({
    playerMenu: state.menuListR.data,
    componentSetting: state.componentSettingListR.data,
    copyrightInformation: state.textInformationListR.data,
    userProfile: state.playerProfileR?.data ?? {},
  }));

  // const [loggedIn, setLoggedIn] = useState(Boolean(login));
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  const [liveChatBox, setLiveChatBox] = useState(false);
  const [chatLink, setChatLink] = useState(null);
  const bankDetailSet = userProfile?.player_bank_detail != null;

  const toggleRegisterPopup = () => setShowRegisterPopup(prev => !prev);

  useEffect(() => {
    dispatch(fetchTextInfo("copyright"));
  }, []);

  return (
    <>
      <ChatConfig setChatLink={setChatLink} />
      {/* <LiveChat /> */}
      <footer className="footer background-footer">
        <div className="container">
          <FooterApk />
          <div className="content mt-3">
            <h2 className="title text-section_heading">{props.t("connect_with_us")}</h2>
            {componentSetting?.["social-media"]?.["default-value"] && <SocialMedia />}
            <div className="footer_copy mt-4">
              <p className="footer-p text-heading_copyright_footer">
                {copyrightInformation?.code === "copyright" ? copyrightInformation.value : ""}
              </p>
              {process.env.REACT_APP_ENV !== "prod" && (
                <p className="footer-p text-heading_copyright_footer">{props.t("build_version")}: {process.env.REACT_APP_BUILD_NUMBER}</p>
              )}
            </div>
          </div>
        </div>
      </footer>
      <footer className="footer-mobile">
        <div className={`footer-nav ${loggedIn ? 'footer-nav-grid' : ''}`}>
          {loggedIn && playerMenu.after ? (
            <>
              {['home', 'promotion', 'deposit', 'my-referral', 'live-chat'].map(item => {
                const menuItem = playerMenu.after[item];
                return menuItem?.status && (
                  <React.Fragment key={item}>
                    {item == 'live-chat' ? (chatLink ? (
                      <NavLink
                        key={item}
                        to={chatLink}
                        className={`item ${item === 'register' ? 'regi-item' : ''}`}
                      >
                        <MenuHelper
                          t={props.t}
                          ftpPath={playerMenu?.ftp_path}
                          data={menuItem}
                          footerMenu
                        />
                      </NavLink >
                    ) : (
                      <div onClick={() => setLiveChatBox(!liveChatBox)}>
                        <MenuHelper
                          t={props.t}
                          ftpPath={playerMenu?.ftp_path}
                          data={menuItem}
                          footerMenu
                        />
                      </div>)
                    ) :
                      <NavLink
                        key={item}
                        to={item === 'deposit' ? (bankDetailSet ? "/deposit" : "/bank-details/deposit") : item === 'home' ? '/' : menuItem.code == 'my-referral' ? "referral" : menuItem.code}
                        className={`item ${item === 'deposit' && isDepositActive ? 'active' : ''}`}
                      >
                        <MenuHelper
                          t={props.t}
                          ftpPath={playerMenu?.ftp_path}
                          data={menuItem}
                          footerMenu
                        />
                      </NavLink>
                    }
                  </React.Fragment>
                );
              })}
            </>
          ) : (
            playerMenu.before && (
              <>
                {['home', 'promotion', 'referral', 'live-chat'].map(item => {
                  const menuItem = playerMenu.before[item];
                  return menuItem?.status && (
                    <React.Fragment key={item}>
                      {item == 'live-chat' ? (chatLink ? (
                        <NavLink
                          key={item}
                          to={chatLink}
                          className={`item ${item === 'register' ? 'regi-item' : ''}`}
                        >
                          <MenuHelper
                            t={props.t}
                            ftpPath={playerMenu?.ftp_path}
                            data={menuItem}
                            footerMenu
                          />
                        </NavLink >
                      ) : (
                        <div onClick={() => setLiveChatBox(!liveChatBox)}>
                          <MenuHelper
                            t={props.t}
                            ftpPath={playerMenu?.ftp_path}
                            data={menuItem}
                            footerMenu
                          />
                        </div>)
                      ) : (
                        <NavLink
                          key={item}
                          to={item === 'home' ? '/' : menuItem.code}
                          className={`item ${item === 'register' ? 'regi-item' : ''}`}
                        >
                          <MenuHelper
                            t={props.t}
                            ftpPath={playerMenu?.ftp_path}
                            data={menuItem}
                            footerMenu
                          />
                        </NavLink >
                      )}
                    </React.Fragment>
                  );
                })}

              </>
            )
          )}
        </div>

        {showRegisterPopup && (
          <div className="register-popup">
            <Popup
              handlePoup={toggleRegisterPopup}
              registerpopup
            />
          </div>
        )}
        {liveChatBox && < LiveChat ShowChatBox={liveChatBox} setLiveChatBox={setLiveChatBox} />}
      </footer >
    </>
  );
};

FooterMobile.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(FooterMobile);
